import React from "react";
import classNames from "classnames";
import { ReactSVG } from "react-svg";

import assignIcon from "../shared_components/images/assign_icon.svg";
import chatBubbleIcon from "../shared_components/images/chat_bubble_icon.svg";
import shareIcon from "../shared_components/images/share_icon.svg";

import styles from "./discussion_tools_overlay.module.scss";

interface Props {
  clipTitle: string;
  clipThumbnailUrl: string;
}

export default function DiscussionToolsOverlay({ clipTitle, clipThumbnailUrl }: Props) {
  return (
    <div className={styles.backgroundContainer}>
      <div className="px-4">
        <div className={classNames(styles.actionMenu, "rounded text-muted")}>
          <div className="mb-2">Start a Live Discussion</div>
          <div>Assign to Students</div>
        </div>

        <div className="d-flex mt-5">
          <h5 className={styles.clipTitle}>{clipTitle}</h5>

          <div className="flex-grow-1"></div>

          <div className="flex-shrink-0">
            <button type="button" className="btn btn-sm btn-outline-dark me-2" tabIndex={-1}>
              <ReactSVG src={assignIcon} wrapper="span" />
            </button>

            <button type="button" className="btn btn-sm btn-outline-dark me-2" tabIndex={-1}>
              <ReactSVG src={chatBubbleIcon} wrapper="span" />
            </button>

            <button type="button" className="btn btn-sm btn-outline-dark" tabIndex={-1}>
              <ReactSVG src={shareIcon} wrapper="span" />
            </button>
          </div>
        </div>

        <div className="mt-2 text-center">
          <img
            src={clipThumbnailUrl}
            className={classNames("rounded", styles.thumbnail)}
            width="100%"
            alt="Video thumbnail"
          />
        </div>

        <div className="mt-3">
          <div className={styles.videoDescPlaceholder100}></div>
          <div className={styles.videoDescPlaceholder85}></div>

          <div className="mt-2">
            <div className={styles.videoDescPlaceholder75}></div>
            <div className={styles.videoDescPlaceholder65}></div>
          </div>
        </div>
      </div>
    </div>
  );
}